module.exports = __webpack_public_path__ + "img/cresol.d01fc8ac.svg";